/*                                                                                                                
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--'
*/

import { IdName } from './asset';
import { BaseService } from './base';

export interface GeofenceDTO {
    id: IdName;
    colour: string;
    geometry: google.maps.LatLng[];
    description: string;
}

/** REST API access
 *
 */
export class GeofenceService extends BaseService {
    public cache?: Promise<GeofenceDTO[]>;

    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('Geofence Service Loaded');
            resolve('Loaded');
        });
    }

    async save(data: GeofenceDTO) {
        if (data.id.id == undefined || data.id.id == '') {
            const response = await this.post<GeofenceDTO>(this.url + '/api/' + this.orgid + '/geofence', data);
            return response;
        } else {
            const response = await this.put<GeofenceDTO>(this.url + '/api/' + this.orgid + '/geofence', data);
            return response;
        }
    }

    public cachedFetchData(): Promise<GeofenceDTO[]> {
        // Check if the data for the given id is already cached
        if (this.cache) {
            return this.cache;
        }

        // If not cached, fetch the data and store the promise in the cache
        const promise = this.fetchData();
        this.cache = promise;
        return promise;
    }

    private fetchData(): Promise<GeofenceDTO[]> {
        const url = this.url + '/api/' + this.orgid + '/geofence';
        return fetch(url, {
            method: 'GET',
            headers: this.headers(),
        }).then((response) => {
            return response.json();
        });
    }

    async deleteGeofence(id: string) {
        const response = await this.delete<GeofenceDTO>(this.url + '/api/' + this.orgid + '/geofence', id);
        return response;
    }
}
